import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// tslint:disable:max-line-length
import { EntitlementGuard } from './services/entitlement.guard';
import { LoginGuard } from './services/login.guard';
import { HeaderService } from './services/header.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PaginationConfig, PaginationModule } from 'ngx-bootstrap/pagination';
import { ClickOutsideDirective } from './messages/click-outside.directive';
import { ShipService } from './services/ship.service';
import { AuthService } from './services/auth.service';
import { ShipUserService } from './services/ship-user.service';
import { ShipRosterComponent } from './ships/ship-roster/ship-roster.component';
import { MarinesBulkEnrollmentComponent } from './ships/bulk-cards/marines/marines-bulk-enrollment/marines-bulk-enrollment.component';
import { ShipLogsComponent } from './ships/ship-logs/ship-logs.component';
import { AuthInterceptorService } from './services/auth-interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    ClickOutsideDirective,
    ShipRosterComponent,
    MarinesBulkEnrollmentComponent,
    ShipLogsComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    AppRoutingModule,
    PaginationModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    HeaderService,
    LoginGuard,
    EntitlementGuard,
    PaginationConfig,
    ShipService,
    AuthService,
    ShipUserService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
